import axios from 'axios'

const BASE = '/admin/user'

const getUsers = (params = {}) => {
  return axios.get(BASE, { params })
}

const getUser = (systemId) => {
  return axios.get(`${BASE}/${systemId}`)
}

const checkUserExists = (systemId) => {
  return axios.get(`${BASE}/${systemId}/exists`)
}

const createUser = (payload) => {
  return axios.post(BASE, payload)
}

const updateUser = (systemId, payload) => {
  return axios.put(`${BASE}/${systemId}`, payload)
}

const getCountries = () => {
  return axios.get('/admin/countries')
}

const getUserTypes = () => {
  return axios.get('/admin/user-types')
}

export default {
  getUsers,
  getUser,
  checkUserExists,
  createUser,
  updateUser,
  getCountries,
  getUserTypes
}
